import { Col, Container, Row } from "react-bootstrap";
import CardComponent from "./card";

import { zoomInDown } from 'react-animations'
import Radium from 'radium';
import projects from './project'
import { Component } from "react";
import { TimelineMax } from "gsap";

export default class GridCards extends Component {


    constructor(props) {
        super(props)
        this.styles = {
            zoomInDown: {
                animation: 'x 2s',
                animationName: Radium.keyframes(zoomInDown, 'zoomInDown')
            }
        }

        this.myRow = null;
        this.myButton = null;
        this.myContainer = null;
        this.timeLine = null;
    }


    componentDidMount() {
        // use the node ref to create the animation
        this.myRow.style.display = 'none'
        this.timeLine = new TimelineMax({ paused: true })
            .to(this.myContainer, 0.5, { opacity: 0, y: -100, display: 'none' })
            .to(this.myRow, 0.5, { opacity: 1, y: -150, display: 'flex' })

    }

    visibleProjects = () => {
        this.timeLine.play()
    }

    hideProjects = () => {
        this.timeLine.reverse()
    }


    render() {
        return (

            <Container fluid style={{ height: "100vh", }}>
                <Row style={{ width: "100vw", justifyContent: "center" }} className="h-100">
                    <Col className="my-auto">
                        <Container fluid>
                            <Row style={{ marginBottom: 15, marginTop: 30 }} ref={cont => this.myContainer = cont}>
                                <Col>
                                    <div >
                                        <h1 className="mx-auto text-center my-auto" style={{ color: "#fff" }}>José Eduardo Morán Reyes</h1>
                                        <h4 className="mx-auto text-center my-auto" style={{ color: "rgb(255, 255, 255, 0.4)" }}>SOFTWARE DEVELOPER</h4>
                                        <br></br>
                                    </div>
                                    <Container>
                                        <Row className="justify-content-center" >
                                            <p className="arrow up" onClick={this.visibleProjects}></p>
                                        </Row>
                                    </Container>
                                </Col>
                            </Row>
                            <Row style={{ justifyContent: "center", marginBottom: 15, paddingTop: 30 }} className="row-opacity" ref={Row => this.myRow = Row} >
                                {projects.projects.map((project, i) =>
                                    <CardComponent className="col-8" key={i} project={project} />
                                )}


                                <Container>
                                    <Row className="justify-content-center" >
                                        <p ref={row => this.myButton = row} className="arrow down" onClick={this.hideProjects}></p>
                                    </Row>
                                </Container>
                            </Row>
                        </Container>
                    </Col>
                </Row>
            </Container >

        );
    }
}
